<button mat-button color="primary-outline" [routerLink]="['/kvvm-reports']">Bekijk alle rapportages</button>
<ng-container *ngIf="dataLoaded && !missingData.length">
	<dl *ngIf="report">
		<dt>Rapportage nummer</dt>
		<dd>{{ report.report_nr }}</dd>
		<dt>Datum aangemaakt</dt>
		<dd *ngIf="report.created !== null">{{ report.created | datex:'DD-MM-YYYY' }}</dd>
		<dd *ngIf="report.created === null">-</dd>
		<dt>Datum aangepast</dt>
		<dd *ngIf="report.modified !== null">{{ report.modified | datex:'DD-MM-YYYY' }}</dd>
		<dd *ngIf="report.modified === null">-</dd>
		<dt>Kleurcode</dt>
		<dd><div class="tag" [style.background]="report.color"></div></dd>
		<dt>Ster inspectie</dt>
		<dd>{{ report.tent_star_rating }}</dd>
	</dl>
	<div class="divider">
		<span *ngIf="report.type != 'tent'">Gebouwen</span>
		<span *ngIf="report.type == 'tent'">Tenten</span>
	</div>
	<app-kvvm-reports-buildings-list [smallWidget]="true" style="margin:-10px 0 0 0;"></app-kvvm-reports-buildings-list>
	<div class="divider"><span>Download rapportage</span></div>
	<div class="buttons-in-line" fxLayout="row">
		<button *ngIf="apiService.isOnline" mat-button color="primary-outline" (click)="downloadReport(report.id, 'pdf')">PDF</button>
		<button *ngIf="apiService.isOnline" mat-button color="primary-outline" (click)="downloadReport(report.id, 'xlsx')">XLS</button>
		<button *ngIf="apiService.isOnline && report.building_map" mat-button color="primary-outline" (click)="downloadReport(report.id, 'map')">Map</button>
		<button *ngIf="!apiService.isOnline" mat-button color="grey-outline" (click)="apiService.notAvailableOffline()">PDF</button>
		<button *ngIf="!apiService.isOnline" mat-button color="grey-outline" (click)="apiService.notAvailableOffline()">XLS</button>
		<button *ngIf="!apiService.isOnline && report.building_map" mat-button color="grey-outline" (click)="apiService.notAvailableOffline()">Map</button>
	</div>
	<app-kvvm-reports-comments-list [smallWidget]="true" style="margin:20px 0 0 0;"></app-kvvm-reports-comments-list>
	<app-kvvm-reports-attachments-list [smallWidget]="true" style="margin:20px 0 0 0;"></app-kvvm-reports-attachments-list>
</ng-container>
<div *ngIf="missingData.length" class="alert alert-danger" fxFlex fxLayout="row">
	<mat-icon>warning</mat-icon>
	<h2>Niet alle data is beschikbaar online, ga online om verder te gaan.</h2>
</div>
